/**
 * Bảng điểm tốt nghiệp chọn theo KHOÁ — phần logic thuần, test ở
 * totNghiepKhoa.test.js.
 *
 * Chọn một khoá thì bảng hiện NGAY mọi học viên của khoá (từ `drivings`), kể cả
 * người chưa có bản ghi điểm. Bản ghi `DiemTotNghiep` chỉ được tạo khi người
 * dùng gõ ô đầu tiên của người đó — xem thôi thì không tạo gì (Trung,
 * 21/10/2026).
 */
import { chuanTimKiem } from './invoiceOcrGiaoVien';

/** Ba ô thực hành — trống một ô là "còn thiếu điểm", cùng luật với backend. */
const O_THUC_HANH = ['chuChi', 'hinh', 'duong'];

/** "C1-K30 — 88 HV, 88 GetFly" (+ ", 12 có điểm" khi đã có bản ghi). */
export function nhanKhoa(k) {
  const ten = (k && (k.name || k.code)) || '';
  const phan = [`${k?.soHocVien || 0} HV`, `${k?.soCoGetfly || 0} GetFly`];
  if (k?.soCoDiem) phan.push(`${k.soCoDiem} có điểm`);
  return `${ten} — ${phan.join(', ')}`;
}

/** Còn thiếu điểm: chưa có bản ghi, hoặc trống ít nhất một ô thực hành. Điểm 0 là điểm thật. */
export function thieuDiem(row) {
  if (!row || !row._id) return true;
  return O_THUC_HANH.some((k) => {
    const v = row.diem?.[k]?.value;
    return v === null || v === undefined;
  });
}

/** Dòng chưa có bản ghi → phải POST tạo trước rồi mới PATCH được. */
export function canTaoTruoc(row) {
  return !row || !row._id;
}

/**
 * Vì sao nút "Đồng bộ" GetFly bị khoá; null = bấm được.
 *
 * Chỉ khoá khi biết CHẮC là chưa liên kết (`coGetfly === false`). Dòng của chế
 * độ cũ (danh sách bản ghi đã có) không mang cờ này — giữ nguyên hành vi cũ.
 */
export function lyDoKhongDongBo(row) {
  if (!row) return 'Không có dữ liệu';
  if (row.coGetfly === false) return 'Chưa liên kết GetFly';
  if (!row._id) return 'Chưa có điểm để đồng bộ';
  return null;
}

/** Lọc tại chỗ trong một khoá: tìm tên/mã (gõ có dấu hay không đều ra) + thiếu điểm. */
export function locHocVien(rows, { q, thieuDiem: chiThieu } = {}) {
  const tim = chuanTimKiem(q);
  return (rows || []).filter((r) => {
    if (chiThieu && !thieuDiem(r)) return false;
    if (!tim) return true;
    return chuanTimKiem(r.hoTen).includes(tim) || chuanTimKiem(r.registrationCode).includes(tim);
  });
}

/**
 * Bọc hàm POST tạo bản ghi để mỗi học viên chỉ có MỘT lần gọi đang chạy.
 *
 * Gõ hai ô liền nhau của cùng một người chưa có bản ghi: ô thứ hai vẫn thấy
 * `_id` null (bảng chưa tải lại), và nếu không chặn thì hai POST đi song song.
 * Backend trả lại bản ghi có sẵn nên không đẻ bản trùng, nhưng vẫn không nên dựa
 * vào đó. Lần gọi sau dùng chung promise của lần đầu; tạo xong thì nhớ id; lỗi
 * thì quên đi để lần gõ sau được thử lại.
 *
 * @param {(drivingId: string) => Promise<object>} tao gọi POST, trả bản ghi
 *   hoặc response dạng `{ data: bản ghi }`
 * @returns {(drivingId: string) => Promise<string>} id bản ghi
 */
export function taoBoTaoMotLan(tao) {
  const dangChay = new Map();
  return (drivingId) => {
    const khoa = String(drivingId);
    if (dangChay.has(khoa)) return dangChay.get(khoa);
    // Gọi `tao` NGAY (executor chạy đồng bộ, lỗi ném đồng bộ cũng thành reject).
    const p = new Promise((resolve) => { resolve(tao(drivingId)); })
      .then((res) => {
        const rec = res && res.data && res.data._id ? res.data : res;
        if (!rec || !rec._id) throw new Error('Không tạo được bản ghi điểm cho học viên này');
        return String(rec._id);
      })
      .catch((e) => {
        dangChay.delete(khoa);
        throw e;
      });
    dangChay.set(khoa, p);
    return p;
  };
}
